import React from 'react';
import { Image, ImageProps } from 'semantic-ui-react';

export const ATMImage: React.FC<ImageProps> = (props) => <Image {...props} />;
